import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from "src/app/services/loader/LoaderService";
import { Globals } from "src/environments/Globals";
import { TranslateServiceLocal } from "src/app/services/translateservice/translate.service.local";
import { CommonConstant } from "src/app/shared/constent/applicationcodes";

@Component({
    templateUrl: 'modules.component.html',
    styleUrls: ['./modules.component.css']
})

export class ModulesComponent implements OnInit {
    allowedMenues: any[];
    const = new CommonConstant();

    constructor(private loaderService: LoaderService, private transService: TranslateServiceLocal, private route: Router,
        private activatedRoute: ActivatedRoute, private touster: ToastrService, private globals: Globals) {

    }

    ngOnInit() {
        this.loaderService.display(true);

        let menu = this.globals.getDataFromLocalStorage(this.const.AllowedMenus)
        if (menu) {
            menu = JSON.parse(menu);
            this.allowedMenues = this.parseFlatArrayToTreeArray(menu);
            console.log(this.allowedMenues);
        }

        this.loaderService.display(false);
    }

    parseFlatArrayToTreeArray(list: any): any[] {
        let treeArray: any[] = [];
        treeArray = list.filter(x => x.PageLevel == 0 && x.IsParent == 1);

        treeArray.forEach((element) => {
            element.Visible = false;
            element.Child = list.filter(x => x.ParentID === element.PageID && x.PageLevel == 1)

            element.Child.forEach((childElement) => {
                childElement.Child = list.filter(x => x.ParentID === childElement.PageID && x.PageLevel == 2);
                if (childElement.Child && childElement.Child.length > 0)
                    element.Visible = true;
            });
        });

        return treeArray;
    }

    navigateToModule(moduleId) {
        this.globals.setDataInLocalStorage(this.const.CurrentModuleID, moduleId);
        this.route.navigate(['Dashboard']);
    }
}


